import { TypographyProps } from '@mui/material'
import { Typography } from 'components/Material/index'
import { lightOnSurface, lightOnSurfaceVariant } from 'styles/useTextStyles'

interface BodyTextProps extends TypographyProps {
  text: string | number | JSX.Element
  typeStyle: 'medium' | 'large' | 'small'
  disabled?: boolean
}

export const BodyText: React.FC<BodyTextProps> = ({ text, typeStyle, disabled, ...props }) => {
  return (
    <Typography sx={styles[typeStyle]} {...props} disabled={disabled}>
      {text}
    </Typography>
  )
}

const styles = {
  medium: {
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: lightOnSurface,
    fontFamily: 'BB-Font-Regular'
  },
  large: {
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.5px',
    color: lightOnSurface,
    fontFamily: 'BB-Font-Bold'
  },
  small: {
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
    color: lightOnSurfaceVariant,
    fontFamily: 'BB-Font-Regular'
  }
}
